module.exports = __webpack_public_path__ + "static/media/marketplace.b540b1e3.png";